import { ItemTypes } from '../constants/constants';

// Presse-papiers multi-slots : nombre d'éléments gardés en parallèle.
export const MAX_COPIES = 5;

// Une colonne ne peut accueillir qu'une box simple (l'ajout de colonne crée une
// box unique) ; ailleurs tout est collable sauf un groupe de box, qui n'a de
// sens que dans une diapositive.
const COLUMN_PASTABLE_TYPES = [
  ItemTypes.SHAPE,
  ItemTypes.LINE,
  ItemTypes.IMG,
  ItemTypes.TEXT,
  ItemTypes.CHECKBOXS_VARIABLE,
  ItemTypes.TEXT_VARIABLE,
  ItemTypes.SELECTOR_VARIABLE,
  ItemTypes.ACCORDION_PANEL,
  ItemTypes.INFO_CARD,
];

// Ajoute une copie en tête du presse-papiers. Recopier un élément déjà présent
// le remonte au lieu d'ajouter un doublon, et seules les MAX_COPIES plus
// récentes sont conservées.
export const pushCopy = (copies, { sourceId, item }) =>
  [
    { sourceId, item },
    ...copies.filter((entry) => entry.sourceId !== sourceId),
  ].slice(0, MAX_COPIES);

// Item de glisser d'une vignette du presse-papiers. Un container copié part tel
// quel, grille comprise (colonnes ET lignes imbriquées, cf. `layout` posé par
// CopyContainer) : n'en recopier que quelques champs perdait en route ce que le
// collage doit reconstruire — le container tombait à plat, sans ses lignes ni
// les box qu'elles portent.
export const copyDragItem = (copy) => {
  if (copy?.type === ItemTypes.CONTAINER_COPIED) {
    return {
      ...copy,
      boxes: (copy.boxes ?? []).map((box) => ({ ...box, copied: true })),
    };
  }
  return { ...copy, copied: true };
};

export const canPasteCopy = (copy, { columnId } = {}) => {
  if (!copy) return false;
  if (columnId) return COLUMN_PASTABLE_TYPES.includes(copy.type);
  return copy.type !== ItemTypes.GROUP_BOXES;
};
